/* eslint-disable */
import React, { Component } from "react";
import cookie from "react-cookies";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  Sector,
  ResponsiveContainer,
} from "recharts";


class PopularItems extends Component {
  constructor(props) {
    super(props);
    var companyID = cookie.load("companyID");
    let selectedTransArr = props.selectedTrans;
    let selectedItams = [];
    let selectedTrans = [];
    if(selectedTransArr != "" && Object.keys(selectedTransArr).length > 0) {
        selectedTrans = props.selectedTrans;
        selectedItams = selectedTransArr.map(selectedTran => selectedTran.name);
    }
    
    this.state = {
      companyID: '',
      selectedItams: selectedItams,
      selectedTrans: selectedTrans,
      clearTrans: 'No'
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if(nextProps.clearTrans !== this.state.clearTrans) {
      let selectedItams = this.state.selectedItams;
      let selectedTrans = this.state.selectedTrans;
      if(nextProps.clearTrans == 'Yes') {
          selectedItams = [];
          selectedTrans = [];
      }
      this.setState({clearTrans: nextProps.clearTrans, selectedItams: selectedItams, selectedTrans: selectedTrans}, function() {
            if(nextProps.clearTrans == 'Yes') {
                this.props.sateValChange('clearTrans', 'No');
            }
      });
    }
  }

  componentDidMount() {

  }

  handleMerchantClick(chartData) {
       let nameTxt = chartData.name;
       let transIdsArr = {'name':chartData.name,'itemType':chartData.itemType,'transIDs':chartData.transIDs};
       let selectedItams = this.state.selectedItams;
       let selectedTrans = this.state.selectedTrans;
       if(selectedItams.includes(nameTxt)) {
        var itemIndx = selectedItams.indexOf(nameTxt);
            selectedItams.splice(itemIndx,1);
            selectedTrans.splice(itemIndx,1);
            this.setState({ selectedItams: selectedItams, selectedTrans: selectedTrans}, function () {
                this.props.sateValChange('selectedTrans', selectedTrans);
            });
       } else {
        var itemIndx = Object.keys(selectedItams).length;
        let sltItems = [...selectedItams, nameTxt];
            selectedTrans[itemIndx] = transIdsArr;
            this.setState({ selectedItams: sltItems, selectedTrans: selectedTrans}, function () {
                this.props.sateValChange('selectedTrans', selectedTrans);
            });
       }
       console.log('SDDDDDWell', chartData);
  }

  handleClick = (data) => {
    alert(`Filtering by ${data.name}`);
    // You could set a filter or state update here
  }

  render() {
    let popularItemstData = [];
    let chartColors = [];
    if(this.props.popularItemstData != "" && Object.keys(this.props.popularItemstData).length > 0) {
        popularItemstData = this.props.popularItemstData;
    }
    if(this.props.chartColors != "" && Object.keys(this.props.chartColors).length > 0) {
        chartColors = this.props.chartColors;
    }
    let selectedItams = this.state.selectedItams;
    return (<div className="spending_analysis_row popular_items_row">

              <div className="spending_analysis_col1 barchart_maindiv piechart_maindiv">
                  <div className="card barchart_innerdiv">
                    <h5 className="barchart_header">Popular Items</h5>
                    <p className="barchart_header_info">
                        Click on pie sections to filter by item
                    </p>
                    <ResponsiveContainer width="100%" height={300}>
                      <PieChart>
                        <Pie
                          data={popularItemstData}
                          cx="50%"
                          cy="50%"
                          outerRadius={85}
                          dataKey="value"
                          label={({ name }) => name}
                          onClick={(data) => this.handleMerchantClick(data)}
                          cursor="pointer"
                        >
                          {popularItemstData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={selectedItams.includes(entry.name) ? '#0fcb34' : chartColors[index % chartColors.length]} />
                          ))}
                        </Pie>
                        <Tooltip formatter={(value) => [`${value} items`, 'Quantity']} contentStyle={{ paddingTop: '1px', paddingBottom: '1px', fontSize: '12px' }} />
                        <Legend wrapperStyle={{ fontSize: '12px' }} />
                      </PieChart>
                    </ResponsiveContainer>
                  </div>  
              </div>

              <div className="spending_analysis_col2 topspenders_maindiv">
                <div className="card topspenders_innerdiv">
                    <h5 className="topspenders_header">Top Selling Items</h5>
                    <div className="topspenders_table_maindiv">
                      <table className="topspenders_table" style={{width:"100%"}}>
                        <tr>
                          <th style={{width:"80%"}}>Item Name</th>
                          <th style={{width:"20%"}}>Quantity</th>
                        </tr>
                        {popularItemstData.length > 0 && (
                          popularItemstData.map((item, index) => {
                            return (
                              <tr key={index} onClick={this.handleMerchantClick.bind(this,item)}>
                                <td className={selectedItams.includes(item.name)?"activebgcls":""}>{item.name}</td>
                                <td className={selectedItams.includes(item.name)?"activebgcls":""}>{item.value}</td>
                              </tr>
                            );
                          })
                        )}  
                      </table>
                    </div>
                </div>   
              </div>
                 
          </div>);
  }
}

export default (PopularItems);
